module.exports = __webpack_public_path__ + "static/media/favicon-144x144.fc64af65.png";